export const MANUAL_JOURNAL_LINES_LIMIT = 500;
